import { SignInCallbackErrorCode } from '@/common/graphql';
// Imported from the module, not the `@/common/utils` barrel: the barrel pulls in `@/common/components`,
// which cannot load in this file's unit test.
import { SIGN_IN_ERROR_TITLE } from '@/common/utils/constants';

interface SignInErrorContent {
  title: string;
  guideline: string;
}

// A registered employee who only has to retry must not be sent to HR.
export const getSignInErrorContent = (errorCode?: SignInCallbackErrorCode): SignInErrorContent => ({
  title: SIGN_IN_ERROR_TITLE,
  guideline:
    errorCode === SignInCallbackErrorCode.SignInRestartRequired
      ? 'Your sign-in could not be completed. Please sign in again.'
      : 'Ask your local HR to ensure you have registered with your Google Workspace email.',
});
